export default "__VITE_ASSET__CFU5RQyt__"